import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useFormik } from 'formik';
import * as Yup from "yup";
import Select from "react-select";
import { adminMainUrl } from '../../../Config';
import Cookies from "js-cookie"
import { toast } from 'react-toastify';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../../HelperFunctions';
const EditOrganisationOffcanvas = ({
    b64id, refresh, handleClose, show, OrganisationDetail, agentOptions, loadingOrganisationAgentList,
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const navigate = useNavigate();
    const initialValues = {
        customerType: "Individual/Proprietary firm",
        name: "",
        alias: "",
        email: "",
        mobile: "",
        gst_number: "",
        // service_type: "",
        has_sub_agent: false,
        sub_agent_id: 0,
        entity_type: []
    };


    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values) => {
            values.customer_id = atob(b64id);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/organization/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal Server Error";
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            formik.setFieldValue("entity_type", [...formik.values.entity_type, value]);
        } else {
            formik.setFieldValue(
                "entity_type",
                formik.values.entity_type.filter((item) => item !== value)
            );
        }
    };


    useEffect(() => {

        if (OrganisationDetail) {
            let entity_arr = [];
            if (OrganisationDetail.entity_type) {
                //convert entity type into string,
                let parsedArr = JSON.parse(OrganisationDetail.entity_type);
                if (Array.isArray(parsedArr)) {
                    entity_arr = parsedArr
                }
            }

            formik.setFieldValue("customerType", OrganisationDetail?.customerType);
            formik.setFieldValue("name", OrganisationDetail?.name);
            formik.setFieldValue("alias", OrganisationDetail?.alias);
            formik.setFieldValue("email", OrganisationDetail?.email);
            formik.setFieldValue("mobile", OrganisationDetail?.mobile);
            formik.setFieldValue("gst_number", OrganisationDetail?.GST);
            // formik.setFieldValue("service_type", OrganisationDetail?.service_type);
            formik.setFieldValue("has_sub_agent", OrganisationDetail?.has_sub_agent);
            formik.setFieldValue("sub_agent_id", OrganisationDetail?.sub_agent_id);
            formik.setFieldValue("entity_type", entity_arr);
        }
    }, [OrganisationDetail]);

    const [disbaleAgent, setDisableAgent] = useState(false);
    useEffect(() => {
        if (formik.values.has_sub_agent == true) {
            setDisableAgent(true);
            if (formik.values.entity_type.includes("agent")) {
                const updatedEntityType = formik.values.entity_type.filter((item) => item !== "agent");
                formik.setFieldValue("entity_type", updatedEntityType);
            }
        } else {
            setDisableAgent(false);
        }
    }, [formik.values.has_sub_agent])

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Organisation Details</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit} >
                        <div className="row">
                            <div className="col-md-6">

                                <input
                                    type="checkbox"
                                    className='me-2'
                                    name="has_sub_agent"
                                    id="has_sub_agent"
                                    onChange={(e) => {
                                        formik.setFieldValue("has_sub_agent", e.target.checked);
                                        formik.setFieldValue("sub_agent_id", 0);
                                    }}
                                    checked={formik.values.has_sub_agent}
                                />
                                <label htmlFor="" className='form-label mb-0'>
                                    Sub Agent
                                </label>
                            </div>

                            {formik.values.has_sub_agent && <div className="col-md-6">
                                <label htmlFor="name" className='form-label mb-0'>
                                    Sub Agent:
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        options={agentOptions}
                                        styles={customStyles}
                                        name="sub_agent_id"
                                        onChange={option => {
                                            formik.setFieldValue('sub_agent_id', option.value);
                                        }}
                                        value={formik.values.sub_agent_id ? agentOptions.find(option => option.value == formik.values.sub_agent_id || null) : null}
                                        isLoading={loadingOrganisationAgentList}
                                    />
                                </div>
                            </div>}
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="" className='form-label mb-0'>
                                    Type of Organisation
                                </label>
                                <select id="" className="form-control form-control-sm"
                                    name='customerType'
                                    value={formik.values.customerType}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}>
                                    <option value="">Select an option</option>
                                    <option value="Individual/Proprietary firm">Individual/Proprietary firm</option>
                                    <option value="Private or Public Limited Company">Private or Public Limited Company</option>
                                    <option value="Partnership firm">Partnership firm</option>
                                </select>
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="name" className='form-label mb-0'>
                                    Name
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <input
                                        type="text"
                                        maxLength={250}
                                        className="form-control form-control-sm"
                                        id="name"
                                        name='name'
                                        value={formik.values.name}
                                        onChange={(e) => {
                                            const uppercasedValue = e.target.value.toUpperCase();
                                            formik.setFieldValue('name', uppercasedValue);
                                        }}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="alias" className='form-label  mb-0'>
                                    Alias
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <input
                                        type="text"
                                        maxLength={250}
                                        className="form-control form-control-sm"
                                        id='alias'
                                        name='alias'
                                        value={formik.values.alias}
                                        // onChange={formik.handleChange}
                                        onChange={(e) => {
                                            const uppercasedValue = e.target.value.toUpperCase();
                                            formik.setFieldValue('alias', uppercasedValue);
                                        }}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="email" className='form-label  mb-0'>
                                    Email
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <input
                                        type="email"
                                        maxLength={250}
                                        className="form-control form-control-sm"
                                        id='email'
                                        name='email'
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="" className='form-label  mb-0'>
                                    Mobile
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <input
                                        type="text"
                                        maxLength={15}
                                        minLength={10}
                                        className="form-control form-control-sm"
                                        name='mobile'
                                        value={formik.values.mobile}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        onInput={(event) => {
                                            let value = event.target.value;
                                            value = value.replace(/[^0-9]/g, '');
                                            event.target.value = value;
                                        }}
                                    // maxLength={10}
                                    />
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <label htmlFor="" className='form-label  mb-0'>
                                    GST Number
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <input
                                        type="text"
                                        maxLength={250}
                                        className="form-control form-control-sm"
                                        name='gst_number'
                                        value={formik.values.gst_number}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div> */}

                            {/* <div className="col-md-6">
                                <label htmlFor="" className='form-label  mb-0'>
                                    Service Type
                                </label>
                                <div className=" mb-3 mb-sm-0">
                                    <select
                                        className="form-control form-control-sm"
                                        name='service_type'
                                        value={formik.values.service_type}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" disabled>-Select a value-</option>
                                        <option value="Custom Clearance">Custom Clearance</option>
                                        <option value="Freight Forwarding">Freight Forwarding</option>
                                        <option value="Both">Both</option>
                                    </select>
                                </div>
                            </div> */}
                        </div>
                        <div className="row my-2 mt-2">
                            <div className="d-flex align-items-center flex-wrap row-gap-2 gap-2">
                                <div className="form-check ">
                                    <input type="checkbox"
                                        className="form-check-input "
                                        name="entity_type"
                                        id="shipper"
                                        value="shipper"
                                        onChange={handleCheckboxChange}
                                        checked={formik.values.entity_type.includes("shipper")}
                                    />
                                    <label
                                        className="form-label mb-0 mt-0"
                                        htmlFor="shipper"

                                    >
                                        Shipper
                                    </label>
                                </div>

                                <div className="form-check ">
                                    <input type="checkbox" className="form-check-input " id="consignee"
                                        name="entity_type"
                                        value="consignee"
                                        onChange={handleCheckboxChange}
                                        checked={formik.values.entity_type.includes("consignee")} />
                                    <label
                                        className="form-label mb-0 mt-0"
                                        name="entity_type"
                                        htmlFor="consignee"
                                    >
                                        Consignee
                                    </label>
                                </div>
                                <div className="form-check ">
                                    <input type="checkbox" className="form-check-input " id="services"
                                        name="entity_type"
                                        value="services"
                                        onChange={handleCheckboxChange}
                                        checked={formik.values.entity_type.includes("services")} />
                                    <label
                                        className="form-label mb-0 mt-0"
                                        htmlFor="services"

                                    >
                                        Services
                                    </label>
                                </div>
                                {!disbaleAgent && <div className="form-check"
                                    title={disbaleAgent && "You can not select agent as this customer is already created via an agent."}
                                >
                                    <input type="checkbox" className="form-check-input " id="agent"
                                        name="entity_type"
                                        value="agent"
                                        onChange={handleCheckboxChange}
                                        checked={formik.values.entity_type.includes("agent")}
                                        disabled={disbaleAgent}

                                    />
                                    <label
                                        className="form-label mb-0"
                                        htmlFor="agent"
                                        disabled={disbaleAgent}
                                    >
                                        Agent
                                    </label>
                                </div>}
                                <div className="form-check ">
                                    <input type="checkbox" className="form-check-input " id="carrier"
                                        name="entity_type"
                                        value="carrier"
                                        onChange={handleCheckboxChange}
                                        checked={formik.values.entity_type.includes("carrier")} />
                                    <label
                                        className="form-label mb-0 mt-0"
                                        htmlFor="carrier"
                                    >
                                        Carrier
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Updating...</> : "Update"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditOrganisationOffcanvas